import { getCookie, setCookie } from './utils/cookies'

export function saveStorageData(key: string, value: unknown) {
  const jsonValue = JSON.stringify(value)

  try {
    localStorage.setItem(key, jsonValue)
  } catch (e) {
    console.error(e)
    setCookie(key, jsonValue)
  }
}

export function getStorageData(key: string): unknown {
  let data: string | null

  try {
    data = localStorage.getItem(key)
  } catch (e) {
    console.error(e)
    data = getCookie(key)
  }

  if (!data) return {}

  try {
    return JSON.parse(data)
  } catch (e) {
    console.error(e)
    return {}
  }
}
